import { h } from "preact";
import Logo from "../assets/images/logos/Logo";
import registeredCharityLogo from "../assets/images/logos/registered_charity_logo.png";
import config from "../config";
import { connect } from "react-redux";
import { css } from "emotion";
import Breadcrumbs from "./Breadcrumbs";
import { max, firstOfType } from "../utils/CssUtils";

const squareLogo = require("../assets/images/logos/square.svg");

const headings = {
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 14,
  textTransform: "uppercase"
};

const widthWrapper = css({
  margin: "0 auto",
  maxWidth: "1200px",
  position: "relative",
  minHeight: 250,
  padding: 12,
  paddingLeft: 60,
  paddingTop: 45,
  "@media(max-width: 500px)": {
    padding: 14
  }
});

const underBar = css({
  margin: "0 auto",
  maxWidth: "1200px",
  padding: "12px 60px",
  textAlign: "center",
  "@media(max-width: 500px)": {
    padding: "8px 14px"
  }
});

const desktop = css({
  [max(768)]: {
    display: "none"
  }
});

const Footer = ({ event, tours: { tour = {} } }) => {
  let theme = event && event.data && event.data.theme ? event.data.theme : {};

  if (typeof window !== "undefined" && window.location) {
    const pathName = window.location.pathname;
    if (pathName.search("tours/") > 0 && tour) {
      theme = tour.theme;
    }
  }

  const color =
    theme && theme.footerTextColor ? `${theme.footerTextColor}` : "#fff";
  const background =
    theme && theme.footerTextColor ? theme.footerColor : "#4e4757";
  const FooterStyles = {
    width: "100%",
    color: color,
    position: "relative",
    background: background
  };

  const footerLogoColor =
    theme && theme.footerLogoColor ? theme.footerLogoColor : "twoTone";

  const columnStyle = css({
    display: "inline-block",
    marginRight: 85,
    verticalAlign: "top",
    a: {
      color: color
    },
    ul: {
      verticalAlign: "top",
      listStyleType: "none",
      margin: 0,
      fontSize: 14
    },
    li: {
      margin: 0,
      marginBottom: 14
    }
  });

  const logoStyles = css({
    width: "135px",
    height: "32px",
    display: "inline-block",
    marginRight: 85,
    "@media(max-width: 500px)": {
      display: "block",
      margin: "14px auto"
    }
  });

  const registeredCharity = css({
    background: `url(${registeredCharityLogo})`,
    width: "80px",
    height: "80px",
    display: "block",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    textIndent: "-9999px",
    position: "absolute",
    right: 60,
    bottom: 65,
    fontSize: 12,
    "@media(max-width: 500px)": {
      position: "static",
      margin: "0 auto",
      display: "block",
      textAlign: "center"
    }
  });

  const mobile = css({
    display: "none",
    padding: 16,
    [max(768)]: {
      display: "block",
      backgroundColor: "#fff",
      color: "#323232",
      textAlign: "center",
      paddingBottom: 100,
      div: {
        marginBottom: 12
      },
      "div>a": {
        color: "#323232",
        fontSize: 14,
        padding: "0px 12px",
        [firstOfType()]: {
          borderRight: `1px solid #323232`
        }
      },
      img: {
        width: 40,
        height: 40
      }
    }
  });

  return (
    <footer style={FooterStyles}>
      <div className={desktop}>
        <Breadcrumbs event={event} color={color} />
        <div className={widthWrapper}>
          <div className={logoStyles}>
            <a href={config("WEBSITE_URL")}>
              <Logo footerLogoColor={footerLogoColor} width={135} height={32} />
            </a>
          </div>
          <div className={columnStyle}>
            <ul>
              <li>
                <h3 style={headings}>Get In Touch</h3>
              </li>
              <li>
                <a href={`${config("WEBSITE_URL")}/contact-us/buyer-support`}>
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className={columnStyle}>
            <ul>
              <li>
                <h3 style={headings}>Create Your Events</h3>
              </li>
              <li>
                <a href={`${config("WEBSITE_URL")}/host-events`}>Host Events</a>
              </li>
              <li>
                <a href={`${config("CONSOLE_URL")}`}>Create an Event</a>
              </li>
              <li>
                <a href={`${config("WEBSITE_URL")}/pricing`}>Pricing</a>
              </li>
            </ul>
          </div>
          <div className={columnStyle}>
            <ul>
              <li>
                <h3 style={headings}>Get Help</h3>
              </li>
              <li>
                <a href={`${config("WEBSITE_URL")}/contact-us/buyer-support`}>
                  Support
                </a>
              </li>
              <li>
                <a
                  href={`${config(
                    "CONSOLE_URL"
                  )}/public/pdfs/humanitix_promoter_agreement.pdf`}
                >
                  Terms of use
                </a>
              </li>
              <li>
                <a
                  href={`${config(
                    "CONSOLE_URL"
                  )}/public/pdfs/humanitix_privacy_policy.pdf`}
                >
                  Privacy policy
                </a>
              </li>
              <li>
                <a
                  href={`https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees`}
                >
                  Help
                </a>
              </li>
              <li>
                <a href={`${config("WEBSITE_URL")}/contact-us/buyer-support`}>
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <span className={registeredCharity} />
        </div>
        <div>
          <div className={underBar}>
            ©{" "}
            {config("CURRENCY") === "AUD"
              ? "Humanitix Limited"
              : "Humanitix New Zealand Charitable Trust"}{" "}
            {new Date().getFullYear()}
          </div>
        </div>
      </div>

      <div className={mobile}>
        <div>
          <a
            href={`https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees`}
          >
            Help
          </a>
          <a href={`${config("WEBSITE_URL")}/contact-us/buyer-support`}>
            Contact
          </a>
        </div>
        <a href={config("WEBSITE_URL")} aria-label="Humanitix website">
          <img src={squareLogo} alt="Humanitix Logo" />
        </a>
      </div>
    </footer>
  );
};

export default connect(
  state => ({ event: state.event, tours: state.tours }),
  {}
)(Footer);
